module.exports = __webpack_public_path__ + "img/img_communaute2.c398a98d.jpg";